import { useCallback } from "react";
import { useParams } from "react-router-dom";

/**
 * Returns a helper to build store-scoped URLs.
 * Under /loja/:slug context → prepends /loja/<slug>.
 * Outside → returns path as-is.
 */
export function useStoreUrl() {
  const { slug } = useParams<{ slug?: string }>();
  const basePath = slug ? `/loja/${slug}` : "";

  const storeUrl = useCallback(
    (path: string) => {
      // Ensure path starts with /
      const normalized = path.startsWith("/") ? path : `/${path}`;
      return `${basePath}${normalized}`;
    },
    [basePath]
  );

  return { storeUrl, basePath, slug };
}
